// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

// 分页查标签
export async function pageLabel(
  params: {
    current?: number;
    pageSize?: number;
    status?: any;
    searchKey?: any;
    labelType?: any;
  },
  options?: { [key: string]: any },
) {
  return request('/base/label/pageList', {
    method: 'POST',
    data: {
      currentPage: params.current,
      showCount: params.pageSize,
      ...params,
    },
    ...(options || {}),
  });
}

/** 下拉接口v2 */
export async function selectListV2(labelType: any, options?: { [key: string]: any }) {
  return request('/base/label/selectList/v2?labelType=' + labelType, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 新增标签 */
export async function addLabel(body: {}, options?: { [key: string]: any }) {
  return request('/base/label/add', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}

/** 修改标签 */
export async function updateLabel(body: {}, options?: { [key: string]: any }) {
  return request('/base/label/update', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}

/** 删除标签 */
export async function deleteLabel(body: {}, options?: { [key: string]: any }) {
  return request('/base/label/delete', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}

/** 状态切换 */
export async function switchStatus(body: {}, options?: { [key: string]: any }) {
  return request('/base/label/switchStatus', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}

/** 获取打标明细 */
export async function markingDetail(labelCode: any, options?: { [key: string]: any }) {
  return request('/base/label/marking-detail?labelCode=' + labelCode, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 通过关联记录id删除关联记录 */
export async function delateRelation(id: number, options?: { [key: string]: any }) {
  return request('/base/label/delate-relation?id=' + id, {
    method: 'GET',
    ...(options || {}),
  });
}


/** 关联标签 */
export async function relatedLabel(
  body: {
    relatedType: string;
    relatedId: string;
    labelCodes: string[];
  }, options?: { [key: string]: any }) {
  return request('/base/label/related-labels', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}



/** 获取标签记录详情 */
export async function labelDetail(id: number, options?: { [key: string]: any }) {
  return request('/base/label/detail?id=' + id, {
    method: 'GET',
    ...(options || {}),
  });
}
/** 获取验收报告信息 */
export async function getPreReportInfo(body: any[], options?: { [key: string]: any }) {
  return request('/uat-report-record/get-pre-report-info', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}
/** 保存验收报告信息 */
export async function savePreReportInfo(body: {}, options?: { [key: string]: any }) {
  return request('/uat-report-record/save', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}
/** 获取效能指标 */
export async function pageMetric(body?: any, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/efficiency/metric-basic/page', {
    method: 'POST',
    data: {
      currentPage: body?.current,
      showCount: body?.pageSize,
      ...body,
    },
    ...(options || {}),
  });
}
/** 删除效能指标 */
export async function deleteMetric(id: number, options?: { [key: string]: any }) {
  return request('/efficiency/metric-basic/delete?id=' + id, {
    method: 'GET',
    ...(options || {}),
  });
}
/** 新增效能指标 */
export async function createMetric(body: {}, options?: { [key: string]: any }) {
  return request('/efficiency/metric-basic/create', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}
/** 修改效能指标 */
export async function updateMetric(body: {}, options?: { [key: string]: any }) {
  return request('/efficiency/metric-basic/update', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}
/** 获取效能指标详情 */
export async function getMetricDetail(id: number, options?: { [key: string]: any }) {
  return request('/efficiency/metric-basic/detail?id=' + id, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取基线配置 */
export async function pageBaseline(body?: any, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/efficiency/metric-baseline/page', {
    method: 'POST',
    data: {
      currentPage: body?.current,
      showCount: body?.pageSize,
      ...body,
    },
    ...(options || {}),
  });
}
/** 删除基线配置 */
export async function deleteBaseline(id: number, options?: { [key: string]: any }) {
  return request('/efficiency/metric-baseline/delete?id=' + id, {
    method: 'GET',
    ...(options || {}),
  });
}
/** 新增基线配置 */
export async function createBaseline(body: {}, options?: { [key: string]: any }) {
  return request('/efficiency/metric-baseline/create', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}
/** 修改基线配置 */
export async function updateBaseline(body: {}, options?: { [key: string]: any }) {
  return request('/efficiency/metric-baseline/update', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}
/** 获取基线配置详情 */
export async function getBaselineDetail(id: number, options?: { [key: string]: any }) {
  return request('/efficiency/metric-baseline/detail?id=' + id, {
    method: 'GET',
    ...(options || {}),
  });
}
/** 获取无基线指标选择 */
export async function getNoBaselineSelect(body?: any, options?: { [key: string]: any }) {
  return request('/efficiency/metric-basic/no-baseline/select', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}
/** 批量新增基线配置 */
export async function batchCreateBaseline(body: {}, options?: { [key: string]: any }) {
  return request('/efficiency/metric-baseline/batch-add', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}
/** 获取指标选择 */
export async function getBaselineSelect(body?: any, options?: { [key: string]: any }) {
  return request('/efficiency/metric-basic/select', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}
/** 指标状态切换 */
export async function switchMetricStatus(body: {}, options?: { [key: string]: any }) {
  return request('/efficiency/metric-basic/switch-status', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}
/** 获取对比表格列表 */
export async function getContrastTableList(body: {}, options?: { [key: string]: any }) {
  return request('/contrast/table/list', {
    method: 'POST',
    data: {
      ...body,
    },
    ...(options || {}),
  });
}
